import { UserInfo } from './UserInfo/UserInfo';
import { UsersDirectory } from './UsersDirectory/UsersDirectory';
import { DataList } from './DataList/DataList';
import { Connections } from './Connections/Connections';

export const SettingsTabs = [
    {
        id: 1,
        label: 'Informations personnelles',
        role: ['assistant', 'manager'],
        component: <UserInfo />
    },
    {
        id: 2,
        label: 'Répertoire des utilisateurs',
        role: ['manager'],
        component: <UsersDirectory />
    },
    {
        id: 3,
        label: 'Listes de données',
        role: ['manager'],
        component: <DataList />
    },
    {
        id: 4,
        label: 'Historique des connexions',
        role: ['manager'],
        component: <Connections />
    }
];
